import type { FunctionComponent } from "react"

import { CardLayout } from "@/features/companyDetail/components/shared/RecruitmentPatternInformation/CardLayout/CardLayout"
import { Circle } from "@/features/companyDetail/components/shared/RecruitmentPatternInformation/ContractCard/Circle/Circle"
import { useCompanyAnalyticsData } from "@/features/companyDetail/components/shared/RecruitmentPatternInformation/useCompanyAnalyticsData"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./ContractCard.module.css"

export const ContractCard: FunctionComponent = () => {
  const { dataCompany } = useCompanyFetch()
  const { hasEnoughData, topContract } = useCompanyAnalyticsData()
  const { t } = useTranslation(["companies_client"])

  if (!dataCompany) return null
  if (!hasEnoughData || !topContract) return null

  const maxPercent = topContract.contracts[0].percent

  return (
    <CardLayout
      data-testid="recruitementPattern_contract"
      title={t("companies_client.recruitmentPatternInformation.contract.title", {
        name: dataCompany.page.name,
        totalPositions: topContract.totalPositions,
      })}
    >
      <ul className={styles.wrapper}>
        {topContract.contracts.map(contract => {
          return (
            <Circle
              globalXDelta={maxPercent / 2}
              globalYDelta={(100 - maxPercent) / 2}
              key={contract.name}
              name={contract.name}
              percent={contract.displayPercent}
            />
          )
        })}
      </ul>
      <ul aria-hidden="true" className={styles.legend}>
        {topContract.contracts.map(contract => {
          return (
            <li className={styles.item} key={contract.name}>
              {contract.name}
            </li>
          )
        })}
      </ul>
    </CardLayout>
  )
}
